"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const dayoff_style_1 = __importDefault(require("../dayoff.style"));
const dayoff_action_1 = __importDefault(require("../dayoff.action"));
const grid_1 = __importDefault(require("components/templates/grid"));
const authorization_1 = require("utils/authorization");
const card_1 = require("components/molecules/card");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const dayoff_column_1 = __importDefault(require("../dayoff.column"));
const svg_1 = require("components/atoms/svg");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const dayoff_mutation_component_1 = __importDefault(require("./dayoff.mutation.component"));
const modal_1 = require("components/molecules/modal");
const kendo_react_scheduler_1 = require("@progress/kendo-react-scheduler");
const AdjustmentDayOff = () => {
    const { isError, isLoading, isSuccess, isSyncDayOff, dataGrid, dataStates, dataCalendar, errorMessage, } = (0, store_1.useAppSelector)(state => state.adjustment.dayoff);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Adjustment', 'Day Off');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                dispatch(dayoff_action_1.default.getDataCalendar());
                dispatch(dayoff_action_1.default.getDataGrid(dataStates));
            }
            if (!isLoading && dataGrid.length === 0) {
                dispatch(dayoff_action_1.default.getDataCalendar());
                dispatch(dayoff_action_1.default.getDataGrid(dataStates));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, dataGrid]);
    const actionCellRender = (0, custom_cell_grid_1.actionCell)([
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.EditIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(dayoff_action_1.default.onClickMutation({ mutationMode: 'edit', dataItem: d }))
        },
        {
            type: 'other',
            permission: isAuthorized.change,
            icon: (0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
            onClick: d => dispatch(dayoff_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem: d }))
        }
    ]);
    const columnRender = [{
            title: '',
            width: '70px',
            sortable: false,
            filterable: false,
            show: isAuthorized.change,
            cell: actionCellRender,
            locked: true
        }];
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(dayoff_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(dayoff_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        dispatch(dayoff_action_1.default.getDataGrid(newDataStates));
    };
    const onSortChange = (e) => {
        dispatch(dayoff_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        dispatch(dayoff_action_1.default.getDataGrid(newDataStates));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { isDayOff: true, theme: appTheme, title: 'Day Off Adjustment', isLoading: isLoading || isSyncDayOff, onAddNewDayOff: () => {
                    dispatch(dayoff_action_1.default.onClickMutation({ mutationMode: 'add' }));
                }, onSyncData: () => {
                    dispatch(dayoff_action_1.default.onSyncData());
                    dispatch(dayoff_action_1.default.syncDataDayOff());
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(dayoff_action_1.default.getDataCalendar());
                    dispatch(dayoff_action_1.default.getDataGrid(dataStates));
                    dispatch(dayoff_action_1.default.onClickMutation({ isSuccess: false, mutationMode: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, onClose: () => dispatch(dayoff_action_1.default.onCloseError()) }), (0, jsx_runtime_1.jsx)(dayoff_mutation_component_1.default, {}), (0, jsx_runtime_1.jsx)(card_1.CardBody, Object.assign({ style: dayoff_style_1.default.gridCard(appTheme) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'grid', gridTemplateColumns: 'auto auto', columnGap: 24 } }, { children: [(0, jsx_runtime_1.jsx)(kendo_react_scheduler_1.Scheduler, Object.assign({ view: 'month', className: 'dayoff', data: dataCalendar, defaultDate: new Date(), height: 'calc(100vh - 233px)', modelFields: {
                                id: 'id',
                                title: 'event',
                                start: 'start',
                                end: 'end',
                                isAllDay: 'isAllDay',
                            } }, { children: (0, jsx_runtime_1.jsx)(kendo_react_scheduler_1.MonthView, {}) })), (0, jsx_runtime_1.jsx)(grid_1.default, { pageable: true, sortable: true, cardGrid: false, dataGrid: dataGrid, scrollable: 'scrollable', sort: dataStates.sort, dataStates: dataStates, style: dayoff_style_1.default.gridHeight, onSortChange: onSortChange, onFilterChange: onFilterChange, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v), columns: columnRender.concat(dayoff_column_1.default) })] })) }))] }));
};
exports.default = AdjustmentDayOff;
